export default {
  success: false,
  error: false, // ожидается строка содержания сообщения об ошибке,
  load: false
}
